import { maxBy, minBy } from 'es-toolkit';

import { type AchievementStandard, type AttachmentState } from '../hooks/types';

export const getPromptData = (
  attachmentState: AttachmentState,
  textPrompt: string,
) => {
  return {
    prompt_type: getPromptType(attachmentState, textPrompt),
    text_prompt: textPrompt,
    file_name:
      attachmentState.type === 'file' ? attachmentState.data.name : null,
    youtube_id:
      attachmentState.type === 'youtube' ? attachmentState.data.videoId : null,
  };
};

export const getStandardCodeData = (standards: AchievementStandard[]) => {
  const selectedStandardCodes = standards.map(standard => standard.code);
  return {
    selected_standard_codes: selectedStandardCodes,
    selected_standard_codes_count: selectedStandardCodes.length,
    highest_score: maxBy(standards, standard => standard.score)?.score,
    lowest_score: minBy(standards, standard => standard.score)?.score,
  };
};

export const AI_GENERATION_EVENT_KEY = 'ai_문제생성_완료';

const getPromptType = (
  attachmentState: AttachmentState,
  textPrompt: string,
) => {
  const promptTypes = [];

  if (!textPrompt.trim()) promptTypes.push('query');

  if (attachmentState.type === 'file') promptTypes.push('file');

  if (attachmentState.type === 'youtube') promptTypes.push('youtube');

  if (attachmentState.type === 'website') promptTypes.push('website');

  return promptTypes.join(',');
};
